
<q-tooltip
  v-if="enabled"
  :anchor="anchor"
  :self="self"
  :max-width="maxWidth"
  :content-class="'wsk-root wsk-app ws-tooltip ' + (onDark ? 'ws-tooltip--on-dark ' : '') + arrowClass"
  :offset="offset"
  v-bind="$attrs"
>
  <slot></slot>
</q-tooltip>
